import { render, staticRenderFns } from "./PaymentInvoiceBlock.vue?vue&type=template&id=64fc7d4f&"
import script from "./PaymentInvoiceBlock.vue?vue&type=script&lang=js&"
export * from "./PaymentInvoiceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports